import Quill from "quill"
import * as Parchment from "parchment";

////////////////////////////////////////////////////////////////////////////////

const BlockEmbed = Quill.import("blots/block/embed") as typeof Parchment.default.Embed;

class YoutubeBlot extends BlockEmbed {

    static blotName = 'youtube';
    static tagName = 'iframe';

    static create(value: any) {
        
        const node = (super.create(null) as any);
        var idxurl = value.indexOf('?v=');
        if (idxurl > -1) {
            var v = value.substr(idxurl + 3);
            node.setAttribute('src', 'https://www.youtube.com/embed/' + v);
            node.setAttribute('frameborder', '0');
            node.setAttribute('width', '560');
            node.setAttribute('height', '315');
            node.setAttribute('allowfullscreen', true);
        }
        return node;
    }

    static formats(node: any) {
        const format: any = {};
        if (node.hasAttribute('height')) {
            format.height = node.getAttribute('height');
        }
        if (node.hasAttribute('width')) {
            format.width = node.getAttribute('width');
        }
        return format;
    }

    static value(node: any) {
        return node.getAttribute('src');
    }

    format(name: any, value: any) {
        var dom = this.domNode as any;
        if (name === 'height' || name === 'width') {
            if (value) {
                dom.setAttribute(name, value);
            } else {
                dom.removeAttribute(name, value);
            }
        } else {
            super.format(name, value);
        }
    }
}

Quill.register(YoutubeBlot, true);

